import cn from 'classnames';
import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { useSession } from 'next-auth/react';
import { NavBar } from '../../../components/common';
import Head from 'next/head';

function Layout({ children, title, pageProps }) {
  const { data: session, status } = useSession();
  const router = useRouter();

  const isAuthenticated = status === 'authenticated';
  const shouldRender = isAuthenticated || router.pathname === '/login';
  const isDashboard = ['/', '/[teamSlug]'].includes(router.pathname);

  useEffect(() => {
    if (status === 'unauthenticated' && router.pathname !== '/login') {
      router.push(`/login?redirect=${encodeURIComponent(router.asPath)}`);
    }
    if (session?.['error'] === 'RefreshAccessTokenError') {
      router.push(`/login?redirect=${encodeURIComponent(router.asPath)}`);
    }
  }, [status]);

  return (
    <>
      <Head>
        <title>{title}</title>
      </Head>
      {isDashboard && (
        <>
          {/* Background color split screen for large screens */}
          <div
            className="fixed top-0 left-0 w-1/2 h-full bg-white"
            aria-hidden="true"
          />
          <div
            className="fixed top-0 right-0 w-1/2 h-full bg-gray-50"
            aria-hidden="true"
          />
        </>
      )}
      <div
        className={cn('relative min-h-full flex flex-col', {
          'bg-gray-50': !isDashboard,
        })}
      >
        <NavBar />
        {shouldRender && children}
      </div>
    </>
  );
}

export default Layout;
